import { getTimeTrackingReport } from '../data/api';
import { GetTimeTrackingReportParams, TimeTrackingReport } from '../data/types';

import domain from './domain';

export const fetchTimeTrackingReport = domain.createEffect<GetTimeTrackingReportParams, TimeTrackingReport>({
    name: 'fetchTimeTrackingReport',
    handler: async (params) => {
        return await getTimeTrackingReport(params);
    },
});
